import XCirleIcon from "@assets/images/failed-icon.svg";
import SuccessIcon from "@assets/images/success.svg";
import { Snackbar, SnackbarProps } from "@material-ui/core";
import { CloseOutlined } from "@material-ui/icons";
import MuiAlert, { AlertProps, Color } from "@material-ui/lab/Alert";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import SVG from "react-inlinesvg";

const Alert = (props: AlertProps) => (
  <MuiAlert elevation={6} variant="filled" {...props} />
);

interface styleProps {
  verticalCenter?: boolean;
  spaceLeftIconClose?: number;
}

interface SnackbarPropsExtend extends SnackbarProps, styleProps {
  severity: Color;
  verticalCenter?: boolean;
}

const useStyles = makeStyles<styleProps>(
  () => ({
    snackbar: {
      top: props => (props.verticalCenter ? "50%" : 24)
    },
    root: {
      display: "flex",
      alignItems: "center",
      borderRadius: 6,
      "& .MuiAlert-icon": {
        "& svg": {
          width: 24,
          height: 24
        }
      }
    },
    content: {
      display: "flex",
      alignItems: "center"
    },
    closeIcon: {
      marginLeft: props =>
        props.spaceLeftIconClose ? props.spaceLeftIconClose : 60,

      height: 16,
      cursor: "pointer"
    }
  }),
  { name: "SnackbarAlert" }
);

const SnackbarAlert: React.FC<SnackbarPropsExtend> = props => {
  const {
    severity,
    children,
    onClose,
    verticalCenter,
    spaceLeftIconClose,
    ...rest
  } = props;
  const classes = useStyles({ verticalCenter, spaceLeftIconClose });
  const iconNode = (
    <SVG src={severity === "success" ? SuccessIcon : XCirleIcon} />
  );
  const onClickClose = e => {
    onClose(e, "clickaway");
  };
  return (
    <Snackbar
      onClose={onClose}
      autoHideDuration={3000}
      {...rest}
      className={classes.snackbar}
    >
      <Alert severity={severity} icon={iconNode} className={classes.root}>
        <div className={classes.content}>
          <div>{children}</div>
          <CloseOutlined
            data-testid="snackbarAlert-closeIcon"
            className={classes.closeIcon}
            onClick={onClickClose}
          />
        </div>
      </Alert>
    </Snackbar>
  );
};

export default SnackbarAlert;
